<!-- Invalid handler for event “click“: got undefined  @click="formData.xxx" 是 formData.xxx 报的错-->
<!-- 创建采购需求 -->
<template>
  <div class="my-enquiry">
    <!-- <div class="big-title">{{ isCreate ? "创建采购需求" : "需求计划详情" }}</div> -->
    <!--程序报错，暂时注释掉-->
    <el-form
      ref="formDom"
      :rules="formDataRules"
      :model="formData"
      class="form-content"
      size="small"
    >
      <!-- 基本信息 -->
      <div class="container">
        <div class="commodity-list">
          <div class="title">基本信息</div>
          <div class="commodity-content">
            <div class="enquiry-form">
              <el-row>
                <el-col v-if="!isCreate" :span="12">
                  <el-form-item
                    :class="{ item: !isCreate }"
                    label-width="128px"
                    label="需求计划编号："
                    prop="purchaseDemandCode"
                  >
                    <span>{{ formData.purchaseDemandCode }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :class="{ item: !isCreate }"
                    label-width="138px"
                    label="需求计划名称："
                    prop="purchaseDemandName"
                  >
                    <el-input
                      v-if="isCreate"
                      v-model.trim="formData.purchaseDemandName"
                      maxlength="100"
                      show-word-limit
                      class="edit-input"
                      size="small"
                      placeholder="请输入需求名称"
                    ></el-input>
                    <span v-else>
                      <e-tooltip
                        :content="formData.purchaseDemandName"
                        :set-length="20"
                      />
                    </span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :class="{ item: !isCreate }"
                    label-width="138px"
                    label="概算金额："
                  >
                    <span>{{ budgetaryTotalAmount }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    :class="{ item: !isCreate }"
                    label-width="142px"
                    label="需求部门："
                    prop="orgShortName"
                  >
                    <eui-btn
                      v-if="isCreate"
                      type="text"
                      @click="openSelectDepartmentDia"
                    >
                      {{
                        formData.orgShortName
                          ? formData.orgShortName
                          : '请选择需求部门'
                      }}
                    </eui-btn>
                    <span v-else>{{ formData.orgShortName }}</span>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    :class="{ item: !isCreate }"
                    label-width="142px"
                    label="需求申请人："
                    prop="createMemberName"
                  >
                    <span>{{ formData.createMemberName }}</span>
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item label="产品批号：" label-width="142px">
                    <el-input
                      v-if="isCreate"
                      v-model="formData.productBatchNumber"
                      maxlength="100"
                      size="small"
                      placeholder="请输入产品批号"
                      show-word-limit
                    ></el-input>
                    <span v-else>
                      <e-tooltip
                        :content="formData.productBatchNumber"
                        :set-length="20"
                      />
                    </span>
                  </el-form-item>
                </el-col>
              </el-row>
            </div>
          </div>
        </div>
      </div>

      <div class="container">
        <div v-if="isCreate" class="handle-btn">
          <eui-btn @click="openAddMaterialDia">添加物料</eui-btn>
          <eui-btn @click="openBatchImport">批量导入</eui-btn>
        </div>
        <div class="commodity-list">
          <div class="title">物料信息</div>
          <div class="commodity-content" style="padding: 0">
            <!-- table -->
            <div class="table-content">
              <el-table
                :data="formData.purchaseDemandItemAddAOList"
                border
                max-height="455"
                style="width: 100%"
                :header-cell-style="{ background: '#F5F5F5' }"
                :header-cell-class-name="must"
                current-row-key="index"
                class="validate-table"
              >
                <el-table-column label="序号" width="60px" fixed="left">
                  <template slot-scope="scope">
                    <span>{{ scope.$index + 1 }}</span>
                  </template>
                </el-table-column>
                <el-table-column
                  label="物料分类"
                  min-width="150"
                  :show-overflow-tooltip="true"
                >
                  <template slot-scope="scope">
                    <el-form-item
                      :class="{ item: !isCreate }"
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.categoryName'
                      "
                      :rules="formDataRules.categoryName"
                    >
                      <!-- <el-input
                      maxlength="100"
                      show-word-limit
                      class="edit-input"
                      size="small"
                      v-model.trim="scope.row.productName"
                      placeholder="商品名称"
                      :disabled="ifIntegrated"
                    ></el-input> -->
                      <span>{{ scope.row.categoryName }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料编码" min-width="220">
                  <template slot-scope="scope">
                    <!-- :rules="formDataRules.categoryCustomCode" -->
                    <el-form-item
                      :class="{ item: !isCreate }"
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.categoryCustomCode'
                      "
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.categoryCustomCode"
                        maxlength="30"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="物料编码"
                      ></el-input>
                      <span v-else>{{ scope.row.categoryCustomCode }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="物料描述" min-width="320">
                  <template slot-scope="scope">
                    <el-form-item
                      :class="{ item: !isCreate }"
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.categoryDesc'
                      "
                      :rules="formDataRules.categoryDesc"
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.categoryDesc"
                        maxlength="100"
                        class="edit-input"
                        size="small"
                        placeholder="物料描述"
                      ></el-input>
                      <span v-else>{{ scope.row.categoryDesc }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="计量单位" min-width="120">
                  <template slot-scope="scope">
                    <el-form-item
                      :class="{ item: !isCreate }"
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.baseUnitName'
                      "
                      :rules="formDataRules.baseUnitName"
                    >
                      <!--                      <el-select-->
                      <!--                        v-if="isCreate"-->
                      <!--                        v-model="scope.row.baseUnitName"-->
                      <!--                        placeholder="请选择"-->
                      <!--                        @focus="getBaseUnitName(scope.row.categoryId)"-->
                      <!--                        @change="-->
                      <!--                          baseUnitNameChange(scope.row.categoryId, scope.$index)-->
                      <!--                        "-->
                      <!--                      >-->
                      <!--                        <el-option-->
                      <!--                          v-for="item in baseUnitNameList"-->
                      <!--                          :key="item.unitName"-->
                      <!--                          :label="item.unitName"-->
                      <!--                          :value="item.unitName"-->
                      <!--                        ></el-option>-->
                      <!--                      </el-select>-->

                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.baseUnitName"
                        maxlength="10"
                        class="edit-input"
                        size="small"
                        placeholder="计量单位"
                      ></el-input>

                      <span v-else>{{ scope.row.baseUnitName }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="规格型号" min-width="220">
                  <template slot-scope="scope">
                    <el-form-item
                      :class="{ item: !isCreate }"
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.specifications'
                      "
                      :rules="formDataRules.specifications"
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.specifications"
                        maxlength="100"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="规格型号"
                      ></el-input>
                      <span v-else>{{ scope.row.specifications }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="需求数量" min-width="150">
                  <template slot-scope="scope">
                    <el-form-item
                      :class="{ item: !isCreate }"
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.quantity'
                      "
                      :rules="formDataRules.quantity"
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.quantity"
                        maxlength="10"
                        class="edit-input"
                        size="small"
                        placeholder="需求数量"
                      ></el-input>
                      <span v-else>{{ scope.row.quantity }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="概算单价（元）" min-width="150">
                  <template slot-scope="scope">
                    <el-form-item
                      :class="{ item: !isCreate }"
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.budgetaryPrice'
                      "
                      :rules="formDataRules.budgetaryPrice"
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.budgetaryPrice"
                        class="edit-input"
                        size="small"
                        maxlength="25"
                        placeholder="概算单价"
                      ></el-input>
                      <span v-else>{{ scope.row.budgetaryPrice }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="" min-width="160">
                  <template slot="header">
                    <span>期望到货日期</span>
                    <i
                      v-if="isCreate"
                      class="el-icon-edit"
                      style="padding: 0 4px; cursor: pointer"
                      @click="openChageTime"
                    ></i>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :class="{ item: !isCreate }"
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.expectedArrivalDate'
                      "
                      :rules="formDataRules.expectedArrivalDate"
                    >
                      <el-date-picker
                        v-if="isCreate"
                        v-model="scope.row.expectedArrivalDate"
                        type="date"
                        placeholder="选择日期时间"
                        value-format="yyyy-MM-dd"
                        :picker-options="pickerReleaseTimeDate"
                      ></el-date-picker>
                      <span v-else>{{ scope.row.expectedArrivalDate }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="图号">
                  <template slot="header">
                    图号<span
                      class="el-icon-edit"
                      @click="openDialog('imageNumber', '图号')"
                    ></span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.imageNumber'
                      "
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.imageNumber"
                        maxlength="100"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="请输入"
                      ></el-input>
                      <span v-else>{{ scope.row.imageNumber }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="订货方">
                  <template slot="header">
                    订货方<span
                      class="el-icon-edit"
                      @click="openDialog('buyer', '订货方')"
                    ></span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'purchaseDemandItemAddAOList.' + scope.$index + '.buyer'
                      "
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.buyer"
                        maxlength="100"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="请输入"
                      ></el-input>
                      <span v-else>{{ scope.row.buyer }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="件号">
                  <template slot="header">
                    件号<span
                      class="el-icon-edit"
                      @click="openDialog('partNumber', '件号')"
                    ></span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.partNumber'
                      "
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.partNumber"
                        maxlength="100"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="请输入"
                      ></el-input>
                      <span v-else>{{ scope.row.partNumber }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="标准">
                  <template slot="header">
                    标准<span
                      class="el-icon-edit"
                      @click="openDialog('standard', '标准')"
                    ></span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.standard'
                      "
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.standard"
                        maxlength="100"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="请输入"
                      ></el-input>
                      <span v-else>{{ scope.row.standard }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column width="160" align="center" label="备注">
                  <template slot="header">
                    备注<span
                      class="el-icon-edit"
                      @click="openDialog('remark', '备注')"
                    ></span>
                  </template>
                  <template slot-scope="scope">
                    <el-form-item
                      :prop="
                        'purchaseDemandItemAddAOList.' +
                        scope.$index +
                        '.remark'
                      "
                    >
                      <el-input
                        v-if="isCreate"
                        v-model.trim="scope.row.remark"
                        maxlength="100"
                        show-word-limit
                        class="edit-input"
                        size="small"
                        placeholder="请输入"
                      ></el-input>
                      <span v-else>{{ scope.row.remark }}</span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <!-- <el-table-column label="需求人" min-width="110">
                <template slot-scope="scope">
                  <el-form-item
                    :class="{ item: !isCreate }"
                    :prop="'purchaseDemandItemAddAOList.' + scope.$index + '.createMemberName'"
                    :rules="formDataRules.createMemberName"
                  >
                    <span>{{ scope.row.createMemberName }}</span>
                  </el-form-item>
                </template>
              </el-table-column> -->
                <el-table-column label="附件" min-width="110" align="center">
                  <template slot-scope="scope">
                    <eui-btn
                      v-if="isCreate"
                      type="text"
                      @click="uploadDesc(scope.$index, scope.row)"
                    >
                      {{
                        scope.row.addPurchaseDemandItemAttachmentAOList &&
                        scope.row.addPurchaseDemandItemAttachmentAOList
                          .length &&
                        scope.row.addPurchaseDemandItemAttachmentAOList[0]
                          .attachmentName
                          ? '已上传'
                          : '上传'
                      }}
                    </eui-btn>
                    <el-form-item v-else>
                      <span
                        class="table-handle-btn"
                        @click="
                          downloadFile(
                            scope.row.addPurchaseDemandItemAttachmentAOList[0]
                              .attachmentName,
                            scope.row.addPurchaseDemandItemAttachmentAOList[0]
                              .attachmentUrl
                          )
                        "
                      >
                        {{
                          scope.row.addPurchaseDemandItemAttachmentAOList &&
                          scope.row.addPurchaseDemandItemAttachmentAOList
                            .length &&
                          scope.row.addPurchaseDemandItemAttachmentAOList[0]
                            .attachmentName
                            ? scope.row.addPurchaseDemandItemAttachmentAOList[0]
                                .attachmentName
                            : ''
                        }}
                      </span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column
                  v-if="isCreate"
                  label="操作"
                  width="100px"
                  fixed="right"
                  align="center"
                >
                  <template slot-scope="scope">
                    <eui-btn
                      type="text"
                      @click="handleDelMaterial(scope.$index, scope.row)"
                    >
                      删除
                    </eui-btn>
                  </template>
                </el-table-column>
              </el-table>
              <!-- <div class="add-table-handle-btn" v-if="!ifIntegrated">
              <span @click="addEnquiryProduct"
                ><i class="el-icon-plus"></i>添加询价商品</span
              >
            </div> -->
            </div>
          </div>
        </div>
      </div>

      <!-- 备注附件 -->
      <div class="container">
        <div class="commodity-list">
          <div class="title">备注附件</div>
          <div class="enquiry-form">
            <el-row>
              <el-col :span="24">
                <el-form-item
                  :class="{ item: !isCreate }"
                  label-width="142px"
                  label="附件："
                >
                  <file-upload
                    v-if="isCreate"
                    :limit="2"
                    :file-size="30"
                    :url="showRemarkList"
                    :upload-url="uploadUrl"
                    :verify="true"
                    :tips-message="tipsMessage"
                    :accept="'.pdf,.xls,.xlsx,.docx'"
                    @getFileInfo="getFileInfo"
                  />
                  <div v-else>
                    <span
                      v-for="item of showRemarkList"
                      :key="item.fileUrl"
                      class="file-name"
                      @click="downloadFile(item.fileName, item.fileUrl)"
                    >
                      {{ dealAttachmentName(item.fileName) }}
                    </span>
                  </div>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row>
              <el-col :span="24">
                <el-form-item
                  :class="{ item: !isCreate }"
                  label-width="142px"
                  label="备注："
                  aria-placeholder="请输入备注信息"
                  prop="remark"
                >
                  <el-input
                    v-if="isCreate"
                    v-model="formData.remark"
                    maxlength="300"
                    show-word-limit
                    style="width: 80%"
                    type="textarea"
                  ></el-input>
                  <span v-else>{{ formData.remark }}</span>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
        </div>
      </div>
      <!-- 审批流程设置 -->
      <div v-if="isCreate" class="container">
        <div class="commodity-list">
          <div class="title">审批流程设置</div>
          <div
            class="enquiry-form"
            style="
              display: flex;
              flex-direction: row;
              justify-content: space-between;
              padding: 20px;
              align-items: center;
            "
          >
            <div class="left">
              <div :class="{ 'margin-l8': !ifSwitch }">
                <div v-if="authFlag && !ifSwitch" class="no-info">
                  <div class="choose-audit">
                    <div class="choose-audit-tip">
                      <img src="@/assets/img/approval/gray-mark.png" alt="" />
                      <span class="gray-color"
                        >贵企业未启用审批流程，无需选择此项。</span
                      >
                    </div>
                    <div
                      v-if="authFlag"
                      class="choose-btn"
                      @click="toSetApprove"
                    >
                      配置审批流
                    </div>
                  </div>
                </div>
                <div
                  v-else-if="!authFlag && ifSwitch && approvalList.length === 0"
                  class="no-info"
                >
                  <div class="choose-audit">
                    <div class="choose-audit-tip">
                      <img
                        src="../../../../../assets/img/approval/exclamation-mark.png"
                        alt=""
                      />
                      <span>贵企业尚未配置审批流，请联系管理员进行配置。</span>
                    </div>
                  </div>
                </div>
                <div v-else-if="ifSwitch" class="no-info">
                  <div v-if="approvalItem.auditName">
                    {{ approvalItem.auditName }}
                  </div>
                  <div v-else class="choose-audit">
                    <div class="choose-audit-tip">
                      <img
                        src="../../../../../assets/img/approval/exclamation-mark.png"
                        alt=""
                      />
                      请选择审批流程
                    </div>
                  </div>
                  <div class="choose-btn" @click="choiceAudit">
                    选择审批流程
                  </div>
                </div>
                <div v-else class="no-info">
                  <div style="display: flex; align-items: center">
                    <img src="@/assets/img/approval/gray-mark.png" alt="" />
                    <span class="gray-color"
                      >贵企业未启用审批流程，无需选择此项。</span
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>

    <div
      v-if="approvalData.length > 0 && !isCreate"
      class="container"
      style="padding-bottom: 20px"
    >
      <!-- 审批流组件-->
      <approval-process
        style="margin-top: -10px"
        :approval-data="approvalData"
      />
    </div>

    <div class="handle-button">
      <eui-btn type="secondary" class="btn back-btn" @click="goBack">
        {{ isCreate ? '取消' : '返回' }}
      </eui-btn>
      <div>
        <eui-btn
          v-if="isCreate"
          v-debounce="() => submitSaveForm()"
          class="btn submit-btn"
        >
          保存
        </eui-btn>
        <eui-btn
          v-if="isCreate"
          v-debounce="() => submitSaveForm('commitPurchaseDemand')"
          class="btn submit-btn"
        >
          提交
        </eui-btn>
      </div>
    </div>

    <!-- 上传物料附件 -->
    <file-material-dia
      :material-file-visible.sync="materialFileVisible"
      :show-file-list="showFileList"
      @getMaterialFile="getMaterialFile"
    />

    <!-- 预算信息 -->
    <budget-dia
      v-if="formData.orgId"
      :budget-visible.sync="budgetVisible"
      :org-id="formData.orgId"
      @chooseData="chooseData"
    />
    <!-- 添加物料 -->
    <add-material-dia
      v-if="addMaterialVisible"
      :add-material-visible.sync="addMaterialVisible"
      @getMaterialList="getMaterialList"
    />
    <!-- 选需求部门 -->
    <select-department-dia
      v-if="selectDepartmentDialogShow"
      :visible="selectDepartmentDialogShow"
      @close="closeSelectDepartmentDialog"
      @getNode="getCurrentNode"
    ></select-department-dia>

    <!-- 批量导入 -->
    <batch-import
      :batch-import-visible.sync="batchImportVisible"
      @getBatchImportList="getBatchImportList"
    />

    <!-- 选择审批流弹窗 -->
    <approve
      :show-audit-mask.sync="showAuditMask"
      :approval-list="approvalList"
      @getApprovalChain="getApprovalChain"
    />

    <!-- 修改期望到货日期弹窗 -->
    <change-time
      :change-time-visible.sync="changeTimeVisible"
      @submitChangeTime="submitChangeTime"
    />

    <!-- 删除弹窗 -->
    <prompt-modal
      :prompt-modal-visible="delVisible"
      :footer="true"
      @close="closeDia('delVisible')"
    >
      <div slot="title" class="prompt-modal-title">
        <!--  <img src="@/static/common/warnIcon.png" alt /> -->
        <p>删除操作</p>
      </div>
      <div slot="content" class="prompt-modal-content">
        <h4>确认删除么?</h4>
      </div>
      <div slot="footer">
        <eui-btn
          type="secondary"
          class="btn-80-30"
          @click="closeDia('delVisible')"
          >关闭</eui-btn
        >
        <eui-btn
          v-prevent-re-click
          class="btn-80-30-primary"
          type="primary"
          @click="handleDel"
        >
          删除
        </eui-btn>
      </div>
    </prompt-modal>
    <!-- 批量输入-->
    <change-data-dialog
      v-if="dataVisible"
      :bitch-data="bitchData"
      :data-visible="dataVisible"
      @bitchChangeData="bitchChangeData"
      @closeDialog="closeDialog"
    />
  </div>
</template>
<script>
import PromptModal from '@/modules/projectA/components/common/promptModal';
import approvalProcess from '@/modules/projectA/components/common/approvalProcess.vue';
import stepUtils from '@/modules/projectA/utils/stepUtils';
import Api from '@/modules/projectA/api/purchase';
import enApi from '@/modules/projectA/api/enquiry';
import currency from 'currency.js';
import utils, { dealAttachmentName } from '@/modules/projectA/utils/utils';
import EuiBtn from 'epec-ui/src/package/eui-btn/index';
import FileMaterialDia from '../components/fileMaterialDia.vue';
import FileUpload from '../components/fileUpload.vue';
import BudgetDia from '../components/budgetDia.vue';
import AddMaterialDia from '../components/addMaterialDia.vue';
import BatchImport from '../components/batchImport.vue';
import ChangeTime from '../components/changeTime.vue';

import Approve from '../components/approveDia.vue';

import selectDepartmentDia from '../components/budgetAddUser.vue';
import changeDataDialog from '../../../components/plan/changeDataDialog';

import eTooltip from '../../../components/common/e-tooltip';

export default {
  components: {
    EuiBtn,
    FileMaterialDia,
    FileUpload,
    BudgetDia,
    AddMaterialDia,
    selectDepartmentDia,
    BatchImport,
    Approve,
    ChangeTime,
    PromptModal,
    approvalProcess,
    changeDataDialog,
    eTooltip,
  },
  props: {
    isCreate: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    function checkEnquiryName(enquiryName) {
      const res = /^[a-zA-Z0-9\u4e00-\u9fa5]|[-_()[]{}，。《》<>]+$/; // 中文 字母 数字
      return res.test(enquiryName);
    }

    function checkNumber(quantity) {
      const numberReg = /^-?\d+(\.\d{1,3})?$/;
      // const numberReg = /^\d+$/;
      return numberReg.test(quantity);
    }
    function validateRequiredQuantity(rule, value, callback) {
      if (!value) {
        return callback(new Error('请输入需求数量'));
      }
      if (value <= 0) {
        return callback(new Error(`需求数量应大于0`));
      }
      if (value > 99999.999) {
        return callback(new Error(`数量不可超过99999.999`));
      }
      if (!checkNumber(value)) {
        callback(new Error('请输入3位以内小数'));
      } else {
        callback();
      }
    }

    /* function validateBudgetaryPriceQuantity(rule, value, callback) {
      if (!value) {
        return callback(new Error("请输入概算单价"));
      }
      if (value <= 0) {
        return callback(new Error(`概算单价需大于0`));
      }
      if (value > 9999999.99) {
        return callback(new Error(`单价不可超过9999999.99`));
      }
      if (!checkNumber(value)) {
        callback(new Error("概算单价保留两位小数"));
      } else {
        callback();
      }
    } */
    function validateBudgetaryPriceQuantity(rule, value, callback) {
      if (value) {
        if (value <= 0) {
          return callback(new Error(`概算单价需大于0`));
        }
        if (value > 9999999.99) {
          return callback(new Error(`单价不可超过9999999.99`));
        }
        if (!checkNumber(value)) {
          callback(new Error('概算单价保留两位小数'));
        } else {
          callback();
        }
      } else {
        return callback();
      }
    }
    // 非必填验证
    function validateCategoryCustomCode(rule, value, callback) {
      if (!value && value !== 0) {
        return callback(new Error('请输入物料编码'));
      }
      if (value) {
        const reg = /^[0-9A-Za-z]+$/;
        if (!reg.test(value)) {
          return callback(new Error(`只能输入字母和数字`));
        }
        callback();
      }
    }

    return {
      bitchData: {
        bitchChangeFlag: '',
        bitchChangeTitle: '',
      },
      dataVisible: false,
      // 删除
      delVisible: false,
      currentIndex: 0,
      batchImportVisible: false,
      budgetVisible: false,
      addMaterialVisible: false,

      integratedTableData: [],
      tipsMessage: '支持excel、pdf、wrod  格式文件,小于30M',
      uploadUrl: '',
      zoneId: '',
      // 回显文件
      showFileList: [],
      categoryInfo: {},
      // 头信息
      productDetail: {},
      limit: 1,
      fileSize: 30,
      // 上传需求描述的index
      clickTableIndex: 0,
      // 列表验证+列表数据
      formData: {
        orgShortName: '',
        orgId: '',
        purchaseDemandName: '',
        createMemberName: '',
        purchaseDemandItemAddAOList: [],
        purchaseDemandAttachmentAddAOList: [],
        remark: '',
        productBatchNumber: '',
        demandAmount: '',
      },
      formDataRules: this.isCreate
        ? {
            purchaseDemandName: [
              {
                required: true,
                message: '请输入需求名称',
                trigger: 'blur',
              },
            ],
            orgShortName: [
              {
                type: 'string',
                required: true,
                message: '请输入选择需求部门',
                trigger: 'blur',
              },
            ],
            categoryDesc: [
              {
                type: 'string',
                required: true,
                message: '请输入物料描述',
                trigger: 'blur',
              },
            ],
            baseUnitName: [
              {
                type: 'string',
                required: true,
                message: '请输入计量单位',
                trigger: 'change',
              },
            ],
            specifications: [
              {
                type: 'string',
                required: true,
                message: '请输入规格型号',
                trigger: 'blur',
              },
            ],
            quantity: [
              {
                required: true,
                validator: validateRequiredQuantity,
                trigger: 'blur',
              },
            ],
            budgetaryPrice: [
              {
                required: false,
                validator: validateBudgetaryPriceQuantity,
                trigger: 'blur',
              },
            ],
            expectedArrivalDate: [
              {
                type: 'string',
                required: true,
                message: '请选择到货日期',
                trigger: 'change',
              },
            ],
            /* categoryCustomCode: [
              {
                required: false,
                validator: validateCategoryCustomCode,
                trigger: 'blur',
              },
            ], */
          }
        : {},
      // 上传需求描述-弹窗
      materialFileVisible: false,
      enquiryTypeFlag: false,
      addressVisible: false,

      selectDepartmentDialogShow: false,
      approvalData: [],
      baseUnitNameList: [],
      purchaseDemandId: '',
      purchaseDemandStatus: '',
      showRemarkList: [],

      pickerReleaseTimeDate: {
        disabledDate: (time) => {
          return new Date(time).getTime() <= Date.now() - 8.64e7;
        },
      },
      changeTimeVisible: false,

      // 审批流字段
      ifSwitch: false,
      approvalList: [],
      activeApproval: {},
      approvalChain: {},
      authFlag: false,
      showAuditMask: false,
      approvalItem: {
        auditId: null,
        auditName: '',
      },
    };
  },
  computed: {
    mall_userInfo() {
      return this.$store.state.USERINFO;
    },
    budgetaryTotalAmount() {
      if (this.formData.purchaseDemandItemAddAOList.length) {
        // console.log(this.formData.purchaseDemandItemAddAOList);
        let countNum = 0;
        this.formData.purchaseDemandItemAddAOList.forEach((item) => {
          countNum += currency(item.budgetaryPrice || 0).multiply(
            item.quantity || 0
          ).value;
        });
        this.formData.demandAmount = countNum.toFixed(2);
        return countNum === 0 ? '--' : `${countNum.toFixed(2)}元`;
      }
      return '--';
    },
  },
  watch: {
    mall_userInfo: {
      immediate: true,
      handler(newVal) {
        if (newVal.companyId) {
          this.companyId = newVal.companyId;
          this.formData.createMemberName = newVal.memberName;
          this.formData.orgId = newVal.departmentId;
          this.formData.orgShortName = newVal.departmentName;

          this.checkAuth();
          this.queryApprovalProcessSwitch();
        }
      },
    },
  },
  mounted() {
    const { purchaseDemandId = '', purchaseDemandStatus = '' } =
      this.$route.query;
    this.purchaseDemandId = purchaseDemandId;
    this.purchaseDemandStatus = purchaseDemandStatus;
    if (purchaseDemandId) {
      this.getDetailInfo(purchaseDemandId);
    }
    this.uploadUrl = Api.requireFileUrl();
  },
  methods: {
    // 批量修改数据
    bitchChangeData(data) {
      this.formData.purchaseDemandItemAddAOList.forEach((item) => {
        this.$set(item, this.bitchData.bitchChangeFlag, data);
      });
    },
    openDialog(flag, title) {
      this.bitchData.bitchChangeFlag = flag;
      this.bitchData.bitchChangeTitle = title;
      this.dataVisible = true;
    },
    closeDialog() {
      this.dataVisible = false;
    },
    // 关闭弹窗
    closeDia(type) {
      this[type] = false;
    },
    // 修改日期
    openChageTime() {
      this.changeTimeVisible = true;
    },
    submitChangeTime(time) {
      console.log(time, 'time');
      this.formData.purchaseDemandItemAddAOList.forEach((item) => {
        item.expectedArrivalDate = time;
      });
    },

    // 是否有配置审批流权限
    async checkAuth() {
      const resData = await enApi.hasAuthCode({
        authCode: '/approveSetting',
      });
      if (resData.code == 200) {
        this.authFlag = resData.data;
      }
    },

    // 获取审批信息
    async getApprovalList() {
      const params = {
        auditType: 3,
      };
      const res = await enApi.approveList(params);
      if (res.code == 200) {
        this.approvalList = res.data;
        if (res.data.length == 1) {
          this.approvalItem = this.approvalList[0];
        }
      }
    },

    // 配置审批流
    toSetApprove() {
      this.$router.push({ path: '/approveSetting' });
    },
    // 选择审批流程
    choiceAudit() {
      this.showAuditMask = true;
    },

    // 判断审批流的开关
    async queryApprovalProcessSwitch() {
      const res = await Api.queryOderConfig();
      if (res.code == 200) {
        if (res.data) {
          const { data } = res.data.find(
            (item) => item.dataType === 'orderDemand'
          );
          this.ifSwitch = data === '41';
          if (this.ifSwitch) {
            this.getApprovalList();
          }
        } else {
          this.ifSwitch = false;
        }
      }
    },
    async getItemPid(val) {
      const res = await Api.approveDetail({ auditId: val });
      if (res.code == 200) {
        this.approvalChain = res.data;
      }
    },
    openApproval(row) {
      this.paramsRow = row;
      this.getApprovalList();
    },
    getApprovalChain(val) {
      this.approvalItem = val;
      console.log(this.approvalItem, 'approvalItem');
    },

    dealAttachmentName,
    openBatchImport() {
      this.batchImportVisible = true;
    },
    // 得到批量导入后的数据
    getBatchImportList(val) {
      val.forEach((item, index) => {
        item.mySkuId = new Date().getTime() + index;
      });
      this.formData.purchaseDemandItemAddAOList = [
        ...val,
        ...this.formData.purchaseDemandItemAddAOList,
      ];
      this.formData.purchaseDemandItemAddAOList.forEach((item) => {
        item.createMemberName = this.formData.createMemberName;
        if (!item.addPurchaseDemandItemAttachmentAOList) {
          this.$set(item, 'addPurchaseDemandItemAttachmentAOList', [
            {
              attachmentName: '',
              attachmentType: 2,
              // 附件类型1:采购需求主表附件 2:采购需求明细附件
              attachmentUrl: '',
            },
          ]);
        }
      });
    },
    downloadFile(fileName, fileUrl) {
      console.log(fileName, fileUrl);
      // 通过 url 下载文件并给文件重新起名字
      const downloadRes = async () => {
        const response = await fetch(fileUrl); // 内容转变成blob地址
        const blob = await response.blob(); // 创建隐藏的可下载链接
        const objectUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = objectUrl;
        a.download = fileName;
        a.click();
        a.remove();
      };
      downloadRes();
    },
    chooseData(val) {
      this.formData.budgetId = val.budgetId;
      this.formData.budgetName = val.budgetName;
    },
    async getDetailInfo(purchaseDemandId) {
      try {
        const result = await Api.queryPurchaseDemandDetail({
          purchaseDemandId,
        });
        const { data } = result;
        this.formData = { ...this.formData, ...data };
        this.approvalItem.auditName = this.formData.auditName;
        this.approvalItem.auditId = this.formData.auditId;
        // 物料
        if (data.purchaseDemandItemDetailVOS?.length) {
          for (let i = 0; i < data.purchaseDemandItemDetailVOS.length; i++) {
            const item = data.purchaseDemandItemDetailVOS[i];
            item.categoryId = Number(item.categoryId);
            if (item.purchaseDemandItemAttachmentDetailVOS.length) {
              item.addPurchaseDemandItemAttachmentAOList =
                item.purchaseDemandItemAttachmentDetailVOS;
            } else {
              this.$set(item, 'addPurchaseDemandItemAttachmentAOList', [
                {
                  attachmentName: '',
                  attachmentType: -1,
                  // 附件类型1:采购需求主表附件 2:采购需求明细附件
                  attachmentUrl: '',
                },
              ]);
              /* item.addPurchaseDemandItemAttachmentAOList = [
                {
                  attachmentName: "",
                  attachmentType: -1,
                  //附件类型1:采购需求主表附件 2:采购需求明细附件
                  attachmentUrl: "",
                },
              ]; */
            }
          }
          this.formData.purchaseDemandItemAddAOList =
            data.purchaseDemandItemDetailVOS;

          this.queryAuditBusinessFlowLogList();
        }
        // 附件
        if (data.purchaseDemandAttachmentDetailVOS?.length) {
          this.formData.purchaseDemandAttachmentAddAOList =
            data.purchaseDemandAttachmentDetailVOS;

          data.purchaseDemandAttachmentDetailVOS.forEach((item) => {
            const obj = {};
            obj.fileName = item.attachmentName || '';
            obj.fileUrl = item.attachmentUrl || '';
            this.showRemarkList.push(obj);
          });
        }

        // 保存之后审批流关闭处理
        if (!this.ifSwitch) {
          this.approvalItem.auditId = null;
        }
      } catch (err) {
        console.log(err);
      }
    },
    // 获取审批流数据
    async queryAuditBusinessFlowLogList() {
      const { companyId } = JSON.parse(localStorage.getItem('USERINFO'));
      const params = {
        companyId,
        businessId: this.$route.query.purchaseDemandId,
        businessAuditType: 3, // 业务审批类型 1:订单 2:预算 3:采购需求 4:采购计划 5:询比价 6:招投标
      };
      const res = await enApi.queryAuditBusinessFlowLogList(params);
      if (res.code === '200' && res.data.length > 0) {
        const data = res.data || [];

        // 封装发起审批人数据
        const firstData = {
          step: '发起审批',
          icon: require('@/assets/img/approval/fqsp.png'),
          auditStatus: 1,
          nodeMember: {
            auditMemberPhone: '',
            auditMemberName: this.formData.createMemberName,
            approveTime: this.formData.createTime,
          },
        };

        // 封装发起审批 的数据 插入第一条
        data.unshift(firstData);
        // 审批流数据封装
        this.approvalData = stepUtils.dealStepData(data);
      }
    },
    async getBaseUnitName(categoryId) {
      this.baseUnitNameList = [];
      try {
        const result = await Api.selectCategoryUnitList({
          categoryId,
        });
        this.baseUnitNameList = result.data;
        /*
          unitCode: "55"
          unitId: 55
          unitName: "批"
        */
      } catch (err) {
        console.log(err);
      }
    },
    baseUnitNameChange(categoryId, index) {
      console.log(categoryId, index);
      const { unitCode = '' } =
        this.baseUnitNameList.find((item) => item.unitCode) || {};
      /*
        baseUnitName	string
        基本计量单位名称（服务取）baseUnitNo
      */
      this.formData.purchaseDemandItemAddAOList[index].baseUnitNo = unitCode;
      console.log(
        this.formData.purchaseDemandItemAddAOList,
        'this.formData.purchaseDemandItemAddAOList'
      );
    },
    getCurrentNode(options) {
      this.formData.orgShortName = options.shortFullName;
      this.formData.orgId = options.orgId;
      this.selectDepartmentDialogShow = false;
    },
    openSelectDepartmentDia() {
      this.selectDepartmentDialogShow = true;
    },
    closeSelectDepartmentDialog() {
      this.selectDepartmentDialogShow = false;
    },
    // 预算弹窗
    openBudgetDia() {
      this.budgetVisible = true;
    },
    // 添加物料弹窗
    openAddMaterialDia() {
      this.addMaterialVisible = true;
    },
    getMaterialList(val) {
      this.formData.purchaseDemandItemAddAOList.push(...val);
    },

    // 得到备注下面附件
    getFileInfo(fileList) {
      console.log('附件：', fileList);
      // 附件类型1:采购需求主表附件 2:采购需求明细附件
      if (fileList?.length) {
        this.formData.purchaseDemandAttachmentAddAOList = fileList.map(
          (item) => ({
            attachmentUrl: item.fileUrl,
            attachmentName: item.fileName,
            attachmentType: 1,
          })
        );
      }
    },
    goBack() {
      // this.$router.push({
      //   path: "/user/user/requirement/requirementList",
      // });
      this.$router.back();
    },

    // 表头加*号
    must(obj) {
      if (this.isCreate) {
        if (
          obj.columnIndex == 5 ||
          obj.columnIndex == 3 ||
          obj.columnIndex == 4 ||
          obj.columnIndex == 6 ||
          obj.columnIndex == 8
        ) {
          return 'must';
        }
      } else {
        return '';
      }
    },
    // 上传需求描述
    uploadDesc(index, row) {
      console.log(row);
      this.clickTableIndex = index;
      this.materialFileVisible = true;

      // 新增 编辑 row.addPurchaseDemandItemAttachmentAOList
      if (this.purchaseDemandId) {
        if (row?.addPurchaseDemandItemAttachmentAOList?.length) {
          this.showFileList = [
            {
              name: row.addPurchaseDemandItemAttachmentAOList[0].attachmentName,
              url: row.addPurchaseDemandItemAttachmentAOList[0].attachmentUrl,
            },
          ];
        }
      } else {
        this.showFileList = [
          {
            name: row.addPurchaseDemandItemAttachmentAOList[0].attachmentName,
            url: row.addPurchaseDemandItemAttachmentAOList[0].attachmentUrl,
          },
        ];
      }
    },
    getMaterialFile(file) {
      console.dir(file, '上传成功的文件数据');
      this.formData.purchaseDemandItemAddAOList[
        this.clickTableIndex
      ].addPurchaseDemandItemAttachmentAOList[0].attachmentName = file.fileName;
      this.formData.purchaseDemandItemAddAOList[
        this.clickTableIndex
      ].addPurchaseDemandItemAttachmentAOList[0].attachmentUrl = file.fileUrl;
      // 附件类型1:采购需求主表附件 2:采购需求明细附件
      this.formData.purchaseDemandItemAddAOList[
        this.clickTableIndex
      ].addPurchaseDemandItemAttachmentAOList[0].attachmentType = 2;
    },
    // 删除-商品
    handleDelMaterial(index) {
      this.currentIndex = index;
      this.delVisible = true;
    },

    handleDel() {
      this.formData.purchaseDemandItemAddAOList.splice(this.currentIndex, 1);
      this.delVisible = false;
    },

    submitSaveForm(sub) {
      console.log(
        this.ifSwitch,
        !this.approvalItem.auditId,
        '!this.approvalItem.auditId'
      );
      console.log(this.formData);
      this.$refs.formDom.validate((valid) => {
        if (valid) {
          console.log(this.formData, '提交创建需求信息');
          let type = sub ? 'commitPurchaseDemand' : 'addPurchaseDemand';
          if (this.purchaseDemandId) {
            /* const {
              purchaseDemandId,
              purchaseDemandStatus,
              // 附件
              purchaseDemandAttachmentAddAOList: updatePurchaseDemandAttachmentAOList,
              // 物料
              purchaseDemandItemAddAOList: purchaseDemandItemUpdateAOList,
            } = this.formData;

            const params = {}; */
            type = sub ? 'commitPurchaseDemand' : 'updatePurchaseDemand';

            this.formData.purchaseDemandId = Number(this.purchaseDemandId);
            this.formData.purchaseDemandStatus = Number(
              this.purchaseDemandStatus
            );

            // 附件
            this.formData.updatePurchaseDemandAttachmentAOList =
              this.formData.purchaseDemandAttachmentAddAOList;
            // 物料
            this.formData.purchaseDemandItemUpdateAOList =
              this.formData.purchaseDemandItemAddAOList;
            if (this.formData.purchaseDemandItemUpdateAOList.length === 0) {
              this.$message.warning('请选择物料');
              return;
            }

            /* delete this.formData.purchaseDemandItemDetailVOS;
            delete this.formData.purchaseDemandAttachmentAddAOList;
            delete this.formData.purchaseDemandItemAddAOList;
            delete this.formData.purchaseDemandAttachmentDetailVOS; */
          }

          if (this.ifSwitch && !this.approvalItem.auditId) {
            this.$message.warning('请选择审批流!');
            return;
          }
          this.formData.auditId = this.approvalItem.auditId || null;
          this.formData.enableWorkflow = this.approvalItem.auditId ? 1 : 0;
          this.formData.auditName = this.approvalItem.auditName || '';
          console.log(this.formData, '提交参数');

          if (type === 'commitPurchaseDemand') {
            console.log(type, 'type');
            this.formData.purchaseDemandItemUpdateAOList =
              this.formData.purchaseDemandItemAddAOList;
            this.formData.updatePurchaseDemandAttachmentAOList =
              this.formData.purchaseDemandAttachmentAddAOList;
          }
          Api[type](this.formData).then((res) => {
            console.log(res);
            if (res.code === '200') {
              this.$message.success('操作成功');
              this.$router.push({
                path: '/demand/demandManage',
              });
            }
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import '@/assets/css/theme.scss';
@import '@/assets/css/mixin/flex.scss';
.btn {
  min-width: 80px;
  text-align: center;
  height: 30px;
  line-height: 27px;
  cursor: pointer;
  padding: 0 10px;
  border-radius: 0;
  margin: 0;
  margin-right: 10px;
}
.right-btn {
  display: flex;
}
.reset-btn {
  background: #e8efff;
  border: 1px solid #2587ff;
  color: #2587ff;
  line-height: 27px;
  &:hover,
  :active {
    background-color: #126edf;
    color: #fff;
  }
}
.submit-btn {
  background: #2587ff;
  border: 1px solid #2587ff;
  color: #ffffff;
  &:hover,
  :active {
    background-color: #126edf;
  }
}
.my-enquiry {
  .big-title {
    color: #333;
    font-weight: bold;
    font-size: 16px;
    margin-bottom: 20px;
    text-align: center;
  }

  .validate-table {
    /* ::v-deep .el-table__row td {
      padding: 8px 0 0 0;
    } */
  }
  ::v-deep .el-radio__input.is-checked .el-radio__inner {
    border-color: #2587ff;
    background: #2587ff;
  }

  ::v-deep .el-radio__input.is-checked + .el-radio__label {
    color: #2587ff;
  }

  .line {
    border-bottom: 1px solid #d9d9d9;
    margin-bottom: 20px;
  }
  .search-form {
    display: flex;
    .el-input {
      width: 200px;
    }
  }
  .form-content {
    .purchase-info {
      border: 1px solid #d9d9d9;
      border-bottom: none;
      padding-top: 18px;
    }
    .no-margin {
      margin-bottom: 0;
    }
    /* .el-col ::v-deep .el-form-item.item {
      margin-bottom: 0;
    } */
    .item ::v-deep .el-form-item__content {
      line-height: 1;
    }
    .item ::v-deep .el-form-item__label {
      line-height: 1;
    }
    ::v-deep .el-select {
      width: 100%;
    }
    ::v-deep .el-date-editor.el-input {
      width: 100%;
      .el-input__inner {
        border-radius: 0;
      }
    }
    ::v-deep .el-input {
      .el-input__inner {
        border-radius: 0;
      }
    }

    .sp-radio {
      margin: 10px 0 0 0;
      ::v-deep .el-radio {
        position: relative;
        margin-right: 60px;
      }
    }

    .left-icon {
      position: absolute;
      left: 96px;
      top: 7px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
    .right-icon {
      position: absolute;
      left: 236px;
      top: 7px;
      width: 18px;
      height: 18px;
      line-height: 16px;
      text-align: center;
      border-radius: 50%;
      border: 1px solid #c5c5c5;
      font-size: 12px;
      color: #c5c5c5;
      cursor: pointer;
      &:hover {
        background: #c5c5c5;
        color: #fff;
      }
    }
  }

  .handle-btn {
    padding-top: 10px;
    margin-bottom: 10px;
    .el-button {
      border-radius: 0;
    }
  }

  .commodity-list {
    border: 1px solid #d9d9d9;
    margin-bottom: 10px;
    &:last-child {
      margin-top: 10px;
    }

    .title {
      color: #333;
      height: 44px;
      line-height: 44px;
      background: #f5f5f5;
      padding-left: 20px;
      border-bottom: 1px solid #d9d9d9;
      font-size: 16px;
      font-weight: bold;
    }

    .commodity-content {
      padding: 0 10px 10px 10px;
      .set-type {
        line-height: 52px;
        i {
          font-size: 20px;
          cursor: pointer;
          &:hover {
            color: #2587ff;
          }
        }
      }

      .table-content {
        .del-btn {
          color: #f0250f;
          cursor: pointer;
          &:hover {
            text-decoration: underline;
          }
        }
        ::v-deep .el-table .el-form-item.item {
          margin-bottom: 0;
        }
        ::v-deep .el-table th.must div:before {
          content: '*';
          color: #ff1818;
        }
        .edit-input {
          ::v-deep .el-input__inner {
            border-radius: 0;
          }
        }
        ::v-deep .el-table th.el-table__cell > .cell {
          font-weight: normal;
          font-size: 14px;
        }
      }

      .table-handle-btn {
        color: #0064c8;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }
      .err-btn {
        color: #f0250f;
        cursor: pointer;
        &:hover {
          text-decoration: underline;
        }
      }

      .add-table-handle-btn {
        margin-top: 10px;
        line-height: 38px;
        text-align: center;
        border: 1px dotted #d9d9d9;
        span {
          cursor: pointer;
        }
      }
    }

    .approval {
      // padding-top: 0;
      height: 70px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 0 20px;
      .info {
        display: flex;
        align-items: center;
        img {
          width: 18px;
          height: 18px;
          margin-right: 10px;
        }
      }
    }
    .enquiry-form {
      padding-top: 20px;
      .left {
        @include flex(start, center, column);
        width: 100%;
        color: #333;
        font-size: 14px;
        line-height: 31px;
        margin: 5px 20px;

        .both-side {
          display: flex;
          justify-content: space-between;
          .receive-address {
            color: #2587ff;
            cursor: pointer;
            border-bottom: 1px solid transparent;
            &:hover {
              border-bottom: 1px solid #2587ff;
            }
          }
        }
        .margin-l8 {
          margin-left: -18px;
        }
        .break {
          text-overflow: -o-ellipsis-lastline;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
        .no-info {
          display: flex;
          align-items: center;
          justify-content: space-between;
          position: relative;
          .choose-btn {
            width: 120px;
            height: 30px;
            background: #2587ff;
            font-size: 14px;
            line-height: 30px;
            text-align: center;
            color: #ffffff;
            cursor: pointer;
          }
          .choose-audit {
            width: 100%;
            display: flex;
            justify-content: space-between;
            .choose-audit-tip {
              display: flex;
              align-items: center;
            }
            .choose-btn {
              width: 120px;
              height: 30px;
              background: #2587ff;
              font-size: 14px;
              line-height: 30px;
              text-align: center;
              color: #ffffff;
              cursor: pointer;
            }
          }
          /* div {
            display: flex;
            align-items: center;
            position: relative;
          } */

          .gray-color {
            color: #c5c5c5;
          }
          img {
            width: 18px;
            height: 18px;
            margin-right: 10px;
          }
        }
      }
      .right {
        .choose-btn {
          width: 120px;
          height: 30px;
          background: #2587ff;
          font-size: 14px;
          line-height: 30px;
          text-align: center;
          color: #ffffff;
          cursor: pointer;
        }
      }
      .file-name {
        margin-right: 10px;
        color: #0064c8;
        cursor: pointer;
      }
      ::v-deep .el-select {
        width: 100%;
      }
      ::v-deep .el-date-editor.el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-input {
        width: 80%;
        .el-input__inner {
          border-radius: 0;
        }
      }
      ::v-deep .el-textarea {
        width: 80%;
        .el-textarea__inner {
          border-radius: 0;
        }
      }

      .address-btn {
        color: #0064c8;
        text-decoration: underline;
        cursor: pointer;
      }
    }
  }
  .handle-button {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
  }
  .pagination {
    margin-top: 18px;
  }
  .warning-content {
    display: flex;
    align-items: center;
    line-height: 56px;
    background: #fffce8;
    padding-left: 10px;
    margin-top: 10px;
    &::before {
      content: '*';
      color: #f0250f;
    }
  }
  .prompt-modal-title {
    display: flex;
    height: 40px;
    padding-left: 20px;
    align-items: center;

    img {
      width: 18px;
      height: 18px;
      margin-right: 10px;
      vertical-align: middle;
    }

    p {
      font-size: 14px;
      font-weight: 500;
      color: $c3;
      line-height: 14px;
    }
  }

  .prompt-modal-content {
    > h4 {
      font-weight: 500;
      color: $c3;
      margin-bottom: 5px;
    }
  }
}
</style>
